import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginGuard } from './core/guards/login.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login', // A página inicial é o login
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
    canActivate: [LoginGuard],
  },
  {
    // Pública: permite configurar el servidor de la API antes de iniciar sesión
    path: 'configuraciones',
    loadComponent: () => import('./pages/configuraciones/configuraciones.page').then(m => m.ConfiguracionesPage)
  },
  // ── Rutas protegidas — requieren sesión válida ────────────
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'lista-clientes',
        loadComponent: () => import('./pages/clientes/lista-clientes/lista-clientes.page').then(m => m.ListaClientesPage),
      },
      {
        path: 'cliente-detalle',
        loadComponent: () => import('./pages/clientes/cliente-detalle/cliente-detalle.page').then(m => m.ClienteDetallePage),
      },
      {
        path: 'documentos',
        loadComponent: () => import('./pages/documentos/documentos').then(m => m.DocumentosPage),
      },
      {
        path: 'menu',
        loadComponent: () => import('./pages/menu/menu.page').then(m => m.MenuPage),
      },
      // --- ROTAS ADICIONADAS AQUI ---
      {
        path: 'clientes-pagares',
        loadComponent: () => import('./pages/pagares-pendientes/clientes-pagares.page').then(m => m.ClientesPagaresPage)
      },
      {
        path: 'pagares-pendientes',
        loadComponent: () => import('./pages/pagares-pendientes/lista-pagares.page').then(m => m.ListaPagaresPage)
      },
      {
        path: 'clientes-pagos',
        loadComponent: () => import('./pages/pagos-pendientes/clientes-pagos.page').then(m => m.ClientesPagosPage)
      },
      {
        path: 'pagos-pendientes',
        loadComponent: () => import('./pages/pagos-pendientes/lista-pagos.page').then(m => m.ListaPagosPage)
      },
      {
        path: 'clientes-pedidos',
        loadComponent: () => import('./pages/pedidos-venta/clientes-pedidos.page').then(m => m.ClientesPedidosPage)
      },
      {
        path: 'pedidos-venta',
        loadComponent: () => import('./pages/pedidos-venta/lista-pedidos.page').then(m => m.ListaPedidosPage)
      },
      {
        path: 'pedidos-venta/:id',
        loadComponent: () => import('./pages/pedidos-venta/detalle-pedido.page').then(m => m.DetallePedidoPage)
      },
      {
        path: 'pedido-form',
        loadComponent: () => import('./pages/pedidos-venta/pedido-form/pedido-form.page').then(m => m.PedidoFormPage)
      },
      {
        path: 'lista-precios',
        loadComponent: () => import('./pages/lista-precios/lista-precios.page').then(m => m.ListaPreciosPage)
      },
      {
        path: 'metas',
        loadComponent: () => import('./pages/metas/metas.page').then(m => m.MetasPage)
      },
      {
        path: 'meta-form',
        loadComponent: () => import('./pages/metas/meta-form/meta-form.page').then(m => m.MetaFormPage)
      },
      {
        path: 'seleccionar-producto',
        loadComponent: () => import('./pages/seleccionar-producto/seleccionar-producto.page').then(m => m.SeleccionarProductoPage)
      },
      {
        path: 'api-test',
        loadChildren: () => import('./pages/api-test/api-test.module').then(m => m.ApiTestPageModule)
      },
      {
        path: 'historial-ventas-anual',
        loadComponent: () => import('./pages/historial-ventas-anual/historial-ventas-anual.page').then(m => m.HistorialVentasAnualPage)
      },
      {
        path: 'cotizaciones',
        loadComponent: () => import('./pages/cotizaciones/cotizaciones.page').then(m => m.CotizacionesPage)
      },
      {
        path: 'cotizacion-producto-form',
        loadComponent: () => import('./pages/cotizaciones/producto-form/producto-form.page').then(m => m.ProductoFormPage)
      },
      {
        path: 'cotizacion-producto-form/:id',
        loadComponent: () => import('./pages/cotizaciones/producto-form/producto-form.page').then(m => m.ProductoFormPage)
      },
      {
        path: 'cotizacion-detalle/:id',
        loadComponent: () => import('./pages/cotizaciones/cotizacion-detalle/cotizacion-detalle.page').then(m => m.CotizacionDetallePage)
      },
      {
        path: 'historial-cotizaciones',
        loadComponent: () => import('./pages/cotizaciones/historial-cotizaciones/historial-cotizaciones.page').then(m => m.HistorialCotizacionesPage)
      },
      {
        path: 'visitas',
        loadComponent: () => import('./pages/visitas/visitas.page').then(m => m.VisitasPage)
      },
      {
        path: 'visita-form',
        loadComponent: () => import('./pages/visitas/visita-form/visita-form.page').then(m => m.VisitaFormPage)
      },
      {
        path: 'visita-form/:id',
        loadComponent: () => import('./pages/visitas/visita-form/visita-form.page').then(m => m.VisitaFormPage)
      },
      {
        path: 'mapa-clientes',
        loadComponent: () => import('./pages/visitas/mapa-clientes/mapa-clientes.page').then(m => m.MapaClientesPage)
      },
      {
        path: 'stock-productos',
        loadComponent: () => import('./pages/stock-productos/stock-productos.page').then(m => m.StockProductosPage)
      },
      {
        path: 'stock-productos/:codigo',
        loadComponent: () => import('./pages/stock-productos/stock-detalle/stock-detalle.page').then(m => m.StockDetallePage)
      },
      {
        path: 'stock-lotes',
        loadComponent: () => import('./pages/stock-lotes/stock-lotes.page').then(m => m.StockLotesPage)
      },
      {
        path: 'stock-lotes-erp',
        loadComponent: () => import('./pages/stock-lotes-erp/stock-lotes-erp.page').then(m => m.StockLotesErpPage)
      },
      {
        path: 'stock-lote-form',
        loadComponent: () => import('./pages/stock-lotes/stock-lote-form/stock-lote-form.page').then(m => m.StockLoteFormPage)
      },
      {
        path: 'stock-lote-form/:id',
        loadComponent: () => import('./pages/stock-lotes/stock-lote-form/stock-lote-form.page').then(m => m.StockLoteFormPage)
      },
      {
        path: 'docs',
        loadComponent: () => import('./pages/docs/docs.page').then(m => m.DocsPage)
      },
    ],
  },
];
